// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__fHUHe","l2":"styles_l2__dtu5g"};